import React from "react";
import ThemeData from "../../../Interfaces/ThemeData";
import Lightbox from "../../../ComponentsForked/react-image-lightbox/src";
import ThemesPopupItem from "./ThemesPopupItem";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setCurrentTheme} from "../../../store/makerDataSlice";
import {ErrorBoundary} from "../../Common/ErrorBoundary";
import ym from "react-yandex-metrika";

interface ThemesPopupProps {
    isPopupOpen: boolean,
    onCloseRequest: () => void,
    onSelectThemeAction: (data: ThemeData) => void
}

const ThemesPopup: React.FC<ThemesPopupProps> = ({
                                                       isPopupOpen,
                                                       onCloseRequest,
                                                       onSelectThemeAction
                                                   }) => {

    const themes = useAppSelector(state => state.makerData.themes)
    const currentTheme = useAppSelector(state => state.makerData.currentTheme)
    const dispatch = useAppDispatch()

    const getCurrentThemeIndex = (): number => {
        return Math.max(Number(themes.findIndex((value) => {
            return currentTheme?.themeId == value.themeId
        })), 0)
    }
    const getPrevTheme = (): ThemeData => {
        const prevTheme = getCurrentThemeIndex() == 0
            ? themes[themes.length - 1]
            : themes[getCurrentThemeIndex() - 1];
        if (prevTheme === undefined)
            return {} as ThemeData;
        else
            return prevTheme;
    }

    const getNextTheme = (): ThemeData => {
        const nextTheme = getCurrentThemeIndex() == Number(themes.length) - 1
            ? themes[0]
            : themes[getCurrentThemeIndex() + 1];
        if (nextTheme === undefined)
            return {} as ThemeData;
        else
            return nextTheme;
    }

    return (
        <div>
            {currentTheme && isPopupOpen && (
                <Lightbox
                    mainSrc={currentTheme?.thumbnailUrl}
                    mainCustomContent={(
                        <ErrorBoundary
                            place={'Theme-ThemesPopupItem-1'}
                            key={currentTheme?.themeId}>
                            <ThemesPopupItem
                                theme={currentTheme}
                                playing={true}
                                onThemeSelect={onSelectThemeAction}
                            >
                            </ThemesPopupItem>
                        </ErrorBoundary>
                    )}
                    nextSrc={getNextTheme().thumbnailUrl}
                    nextCustomContent={(
                        <ErrorBoundary
                            place={'Theme-ThemesPopupItem-2'}
                            key={getNextTheme()?.themeId}>
                            <ThemesPopupItem
                                theme={getNextTheme()}
                                playing={false}
                                onThemeSelect={onSelectThemeAction}
                            >
                            </ThemesPopupItem>
                        </ErrorBoundary>
                    )}
                    prevSrc={getPrevTheme().thumbnailUrl}
                    prevCustomContent={(
                        <ErrorBoundary
                            place={'Theme-ThemesPopupItem-3'}
                            key={getPrevTheme()?.themeId}>
                            <ThemesPopupItem
                                theme={getPrevTheme()}
                                playing={false}
                                onThemeSelect={onSelectThemeAction}
                            >
                            </ThemesPopupItem>
                        </ErrorBoundary>
                    )}
                    onCloseRequest={() => onCloseRequest()}
                    onMovePrevRequest={() => {
                        dispatch(
                            setCurrentTheme(getPrevTheme())
                        )
                        ym('reachGoal', 'playTheme');
                    }}
                    onMoveNextRequest={() => {
                        dispatch(
                            setCurrentTheme(getNextTheme())
                        )
                        ym('reachGoal', 'playTheme');
                    }}
                    enableZoom={false}
                />
            )}
        </div>
    )
}

export default ThemesPopup;